type CommuteScreenStaticData = {
  locationSearchButtonLabel: string;
  pointOfInterestSuggest: {
    label: string;
    placeholder: string;
    noResultsMessage: 'Sorry, no matches found';
  };
};

export const getCommuteScreenStaticData = (): CommuteScreenStaticData => {
  return {
    locationSearchButtonLabel: 'Already have a suburb in mind?',
    pointOfInterestSuggest: {
      label: 'Destination',
      placeholder: 'Work, school or other places',
      noResultsMessage: 'Sorry, no matches found',
    },
  };
};
